import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const FormRadioButtons = ({
  pref,
  type,
  label,
  name,
  value,
  errors,
  items,
  required,
  onChange
}) => (
  <div
    className={classnames("form-group", {
      "has-error": errors && errors.length > 0
    })}
  >
    <label className="control-label word-wrap" htmlFor={`input${name}${pref}`}>
      {label}
      {required ? " *" : ""}
    </label>

    <div>
      {items.map(item => (
        <div key={item.key}>
          <input
            id={`radio${pref}-${item.key}`}
            type="radio"
            name={name}
            value={item.key}
            style={{ width: "auto", marginRight: 10 }}
            checked={item.key.toString() === value}
            onChange={onChange}
          />
          <label htmlFor={`radio${pref}-${item.key}`}>{item.val}</label>
        </div>
      ))}
      {errors ? <span className="help-block">{errors.join(", ")}</span> : null}

      {value ? (
        <div>
          <button href="#" className="btn btn-indigo btn-raised btn-long" name={name} onClick={onChange}>
            Reset
          </button>
        </div>
      ) : null}
    </div>
  </div>
);

FormRadioButtons.propType = {
  pref: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  errors: PropTypes.array,
  value: PropTypes.string,
  items: PropTypes.array,
  required: PropTypes.bool,
  onChange: PropTypes.func
};

FormRadioButtons.defaultProps = {
  required: false
};

export default FormRadioButtons;
